export const Home = () => {
	return ( <>
	<div className="flex items-center justify-center w-screen h-full">
		<div className="resize-x overflow-auto w-12 h-12 bg-gray-500">asdf</div>
	</div>
	</> );
}